import { render, staticRenderFns } from "./KeyMeasureDescriptionLabels.vue?vue&type=template&id=6a98dbde&scoped=true&"
import script from "./KeyMeasureDescriptionLabels.vue?vue&type=script&lang=js&"
export * from "./KeyMeasureDescriptionLabels.vue?vue&type=script&lang=js&"
import style0 from "./KeyMeasureDescriptionLabels.vue?vue&type=style&index=0&id=6a98dbde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98dbde",
  null
  
)

export default component.exports